import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { TokenInterceptor } from './interceptors/token.interceptor';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { AbilityModule, AbilityService } from '@casl/angular';
import { PureAbility } from '@casl/ability';

import { StoreModule } from '@ngrx/store';
import { appReducer } from './app.reducer';
import { AutoLogoutIdleComponent } from './auto-logout-idle/auto-logout-idle.component';
import { PrimeSidebarLayoutComponent } from './modules/shared/layout/prime-sidebar-layout/prime-sidebar-layout.component';
import { SharedModule } from './modules/shared/shared.module';
import { RouterModule, TitleStrategy } from '@angular/router';
import { CustomTitleStrategy } from './title-setter';
@NgModule({
  declarations: [
    AppComponent,
    AutoLogoutIdleComponent,
    PrimeSidebarLayoutComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CommonModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ToastModule,
    AbilityModule,
    StoreModule.forRoot({ app: appReducer }),
    SharedModule,
    RouterModule,
  ],
  providers: [
    {
      provide: PureAbility,
      useValue: new PureAbility(),
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    AbilityService,
    MessageService,
    ConfirmationService,
    Title,
    { provide: TitleStrategy, useClass: CustomTitleStrategy },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
